import { render, staticRenderFns } from "./BaseIntroduction.vue?vue&type=template&id=415f8226&scoped=true&"
import script from "./BaseIntroduction.vue?vue&type=script&lang=js&"
export * from "./BaseIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./BaseIntroduction.vue?vue&type=style&index=0&id=415f8226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f8226",
  null
  
)

export default component.exports